<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { baseUrl, langUrl, getFilePrefix } from '@/helpers'
import { useLangStore } from '@/stores/app/lang'
import { useMainStore } from '@/stores/main'
import { useSlideshowStore } from '@/stores/gallery/slideshow'
import { useMenuStore } from '../stores/gallery/menu'

const { lang } = storeToRefs(useLangStore())
const slideshowStore = useSlideshowStore()
const mainStore = useMainStore()
const menuStore = useMenuStore()

const card = ref(null)

// State -----------------------------------------

// Getters ---------------------------------------
const item = computed(() => slideshowStore.activedItem)

const showFlip = computed(() => menuStore.category !== 4 && menuStore.category !== 5)

// Methods ---------------------------------------
function flipPicture() {
  card.value.classList.toggle('hover')
  const isFlipBack = [...card.value.classList].includes('hover')
  mainStore.setFlipBack(isFlipBack)
  // console.log(isFlipBack.value)
}

// Events ----------------------------------------
function onClickBtnFlip() {
  flipPicture()
}

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <div class="item-picture">
    <template v-if="item">
      <transition name="fade-picture" mode="out-in" appear>
        <div class="flip-card" ref="card" :key="item">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img :src="baseUrl(`/images/gallery/item-picture/${getFilePrefix(item)}_F.png`)" />
            </div>
            <div v-if="showFlip" class="flip-card-back">
              <img :src="baseUrl(`/images/gallery/item-picture/${getFilePrefix(item)}_R.png`)" />
            </div>
          </div>
        </div>
      </transition>
      <template v-if="showFlip">
        <transition name="fade-lang" appear>
          <img
            class="btn-flip"
            :key="lang"
            :lang="lang"
            :src="langUrl('/images/main/th/btn-flip.png')"
            @click="onClickBtnFlip"
          />
        </transition>
      </template>
    </template>
  </div>
</template>

<style scoped>
/* ------------------------ */
.fade-picture-enter-active,
.fade-picture-leave-active {
  transition: opacity 0.4s ease;
}
.fade-picture-enter-from,
.fade-picture-leave-to {
  opacity: 0;
}

/* ------------------------ */
.item-picture {
  position: absolute;
  width: 660px;
  height: 1520px;
}

.btn-flip {
  position: absolute;
  top: 1383px;
  left: 45px;
  cursor: pointer;
}

/* ------------------------ */
</style>
